var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Upload",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,12.1c0,2.6-2.1,4.7-4.6,4.7c0,0,0,0,0,0c-0.4,0-0.7-0.3-0.8-0.7c0-0.4,0.3-0.8,0.7-0.8 c1.8,0,3.2-1.4,3.2-3.2c0-1.6-1.6-2.6-3.1-2.8l-0.5-0.1l-0.1-0.5c-0.5-2.4-2.5-4.7-5.8-4.2C9,4.9,7.6,6.9,7.3,8.8L7.2,9.3L6.6,9.4 C5,9.5,3.3,10.7,3.5,12.5c0.2,1.6,1.5,2.8,3.2,2.8c0,0,0,0,0,0c0,0,0,0,0,0c0.4,0,0.7,0.3,0.8,0.7s-0.3,0.8-0.7,0.8c0,0,0,0,0,0 c-2.4,0-4.4-1.8-4.6-4.1c-0.3-2.3,1.4-4.2,3.9-4.7c0.6-2.2,2.3-4.5,4.8-4.8c3.5-0.5,6.4,1.4,7.3,4.8C20,8.4,22,9.8,22,12.1z M12,8.9 l-4,4c-0.3,0.3-0.3,0.8,0,1.1s0.8,0.3,1.1,0l2.2-2.2v8.5c0,0.4,0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8v-8.5L15,14c0.1,0.1,0.3,0.2,0.5,0.2 s0.4-0.1,0.5-0.2c0.3-0.3,0.3-0.8,0-1.1L12,8.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.00dcd7bf.svg";
export { ForwardRef as ReactComponent };